import { defineFetch } from 'resift';
import { WidgetCreateRequest } from 'pages/Homepage/typings';

const makeCreateWidget = defineFetch({
  displayName: 'Create a Widget',
  make: () => ({
    request: (data: WidgetCreateRequest) => ({ http }) =>
      http({
        method: 'POST',
        route: '/widgets',
        data,
      }),
  }),
});

const createWidget = makeCreateWidget();

export default createWidget;
